var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moow-notification"},[_c('md-button',{staticClass:"md-icon-button notification-close-btn",on:{"click":_vm.close}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331c0011","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/interface/dialogs/moowNotification.vue
// module id = null
// module chunks = 